import React from "react";
var __jsx = React.createElement;
import { BeopContainer, BeopIcon, Container } from './BeopBlock.style';

var BeopBlock = function BeopBlock() {
  return __jsx(Container, {
    "data-testid": "beop-block"
  }, __jsx(BeopContainer, null, __jsx(BeopIcon, null), __jsx("p", null, "Quiz BeOp")));
};

export default BeopBlock;